import { HTTP } from './http-constants'
import * as moment from 'moment';
import Vue from "vue";

export function sessionGet(key) {
    let stringValue = window.sessionStorage.getItem(key);
    if (stringValue !== null) {
        let value = JSON.parse(stringValue)
        let expirationDate = new Date(value.expirationDate)
        if (expirationDate > new Date()) {
            return value.value
        } else {
            window.sessionStorage.removeItem(key)
        }
    }
    return null;
}

// add into session
function sessionSet(key, value, expirationInMin = 10) {
    let expirationDate = new Date(new Date().getTime() + (60000 * expirationInMin));
    let newValue = {
        value: value,
        expirationDate: expirationDate.toISOString()
    }
    window.sessionStorage.setItem(key, JSON.stringify(newValue));
}

function sessionClear(key) {
    if (window.sessionStorage) {
        sessionStorage.removeItem(key);
    }
}

function save_list(values, key) {
    if (window.sessionStorage) {
        if (values.length > 0) {
            sessionSet(key, values);
        } else {
            sessionStorage.removeItem(key);
        }
    }
}

function get_list(path_url, key, cb, force = false) {
    var values = []
    if (window.sessionStorage) {
        values = sessionGet(key)
    }

    if (values && !force) {
        cb(values)
    }
    if (!values || force) {
        HTTP.get(path_url)
            .then(function (re) {
                values = re.data;
                sessionSet(key, values);
                cb(values);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
}

export function getZones(cb) {
    get_list("/tracker_zones/", "zones", cb);
}

export function saveZones(zones) {
    save_list(zones, 'zones');
}


export function getDevices(cb) {
    get_list("/devices/?type=tracker", "devices", cb, true);
}

export function getModeParam(device, cb) {
    let value = undefined
    HTTP.get('/devices/' + device.id + '/tracker_config/mode_param/',)
        .then(function (re) {
            value = re.data;
            cb(value);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function changeModeParam(device, params, cb) {
    HTTP.patch('/devices/' + device.id + '/tracker_config/mode_param/?remote=true', params)
        .then(function (re) {
            cb(re.data);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getTrackerProfile(cb) {
    HTTP.get('/profiles/?type=tracker')
        .then(function (re) {
            if (re.data.length) {
                console.log("profiles", re.data);
                cb(re.data[0]);
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function unlinkDevice(device, cb) {
    if (device.state === 'online' || device.state === 'unknown') {
        cb(false);
        return
    }

    HTTP.delete('/devices/' + device.id + '/unlink/')
        .then(function (re) {
            cb(true);
        })
        .catch(function (error) {
            console.log(error);
            cb(false);
        });
}


export function getTheftForms(device, cb){
    HTTP.get('/devices/'+ device.id + '/theft_form/', {responseType: 'arraybuffer'})
        .then(function (re) {
            console.log("theft form", re);
            cb(re);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getTrackerEvents(device, dt_start, dt_end, cb) {
    HTTP.get('/api/v2/devices/' + device.id + '/trackerevent/', {
        params: {
            timestamp1: dt_start,
            timestamp2: dt_end
        }
    })
        .then(function (re) {
            cb(re.data);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getTrackerDistance(device, dt_start, dt_end, cb) {
    HTTP.get('/api/v2/devices/' + device.id + '/trackerdistance/', {
        params: {
            timestamp1: dt_start,
            timestamp2: dt_end
        }
    })
        .then(function (re) {
            cb(re.data);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function saveDevices(devices) {
    save_list(devices, 'devices');
}

export function getPlaces(cb) {
    get_list("/tracker_places/", "places", cb);
}

export function savePlaces(places) {
    save_list(places, 'places');
}

export function clearPlaces() {
    sessionClear('places');
}

export function pretty_date(value) {
    const now = moment(value);
    return now.fromNow()
}

export function getUserRole(cb) {
    HTTP.get('/options/')
        .then(function (re) {
            let role = re.data.role;
            app.$store.commit('setRole', role);
            cb(role);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export const tracker_modes = {
    'standard': ["1", "2", "3"],
    'vehicle': ["1", "2", "3", "8", "9", "10"],
    'pet': ["21", "22", "23"]
};

export function geocode_position(lat, lng, cb) {
    let position = new google.maps.LatLng(lat, lng);
    let geocoder = new google.maps.Geocoder();
    geocoder.language = window.navigator.language;

    geocoder.geocode({ 'location': position }, function (results, status) {
        if (status === 'OK') {
            if (results[0]) {
                cb(results[0].formatted_address);
            } else {
                window.alert('No results found');
            }
        } else {
            window.alert('Geocoder failed due to: ' + status);
        }
    });
}

export function icon_path(icon_id){
    let myIcons = ['pin', 'sacamain', 'malette', 'valise', 'malette', 'sacados', 'valise', 'velo', 'bateau', 'bateau', 'voiture', 'voiture', 'caravane', 'diable', 'chien', 'kayak', 'laptop', 'moto', 'helicoptere', 'avion', 'avion', 'scooter', 'scooter', 'tente', 'camion', 'camion', 'tracteur', 'camion', 'camion', 'camion', 'chien', 'chat', 'garcon', 'cube', 'fille', 'moto', 'tractopelle', 'animal', 'femme', 'homme', 'trottinette', 'bee', 'carpark', 'gps', 'health', 'homeappliance', 'keys', 'tv', 'phone', 'appareilphoto', 'poussette']
    if (icon_id >= 0 && icon_id <= 50) {
        return "/images/icons/" + myIcons[icon_id] + '.png';
    }

    return "/images/default-marker.png";
}

export function resolve_address(lat, lng, cb) {
    let locationKey = 'lat:' + lat.toFixed(3) + ",lng:" + lng.toFixed(3);
    cb(locationKey);
    let new_address = null;
    if (window.sessionStorage) {
        try {
            new_address = sessionStorage.getItem(locationKey);
        } catch (e) {
            console.log("error getting addr from storage");
        }
    }
    if (new_address != null) {
        cb(new_address);
    } else {
        geocode_position(lat, lng, function (address) {
            cb(new_address);
            sessionStorage.setItem(locationKey, address);
        });
    }
}

export function fmtDate(date) {
    if (!date) return '';
    let options = {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };
    return new Date(date).toLocaleString(undefined, options);
}

export function formatDateForSorting(dateStr) {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hour}:${minute}`;
}

export function trackerType(device) {
     switch (device.type) {
        case "tracker_01":
            if (device.tracker_config.board_name) {
                if (device.tracker_config.board_name.startsWith("LWT2")) {
                    return "Tracker LWT2";
                }
                if (device.tracker_config.board_name.startsWith("SCT2")) {
                    return "Tracker SCT2";
                }
            }
            return "Tracker LWT";

        case "tracker_02":
            return "Tracker SCT";

        case "tracker_03":
            return "Tracker LWT3";

        case "tracker_04":
            return "Smart Dog Collar";

        case "tracker_06":
            return "MiniTailz";

        case "triby":
            return "Triby";

        default:
            return device.type;
    }
}
